import React, { ReactNode } from 'react';
import Card from 'features/shared/components/card/Card';
import styles from './reservedCapacityRow.module.scss';

interface Props {
  children: ReactNode;
}

const ReservedCapacityRow = (props: Props) => {
  return (
    <Card className={`px-3 mb-2 ${styles.row}`}>
      {props.children}
    </Card>
  );
}

export default ReservedCapacityRow;
